<template>
	<v-form @submit.prevent="$emit('submit')">
		<v-row>
			<v-col>
				<validation-provider
					v-slot="{ errors }"
					rules="required"
					slim
					name="domain"
				>
					<v-text-field
						v-model.trim="server.domain"
						label="Domain"
						name="domain"
						:error-messages="errors"
						type="text"
					>
					</v-text-field>
				</validation-provider>
				<validation-provider
					v-slot="{ errors }"
					slim
					rules="required"
					name="timeZones"
				>
					<v-autocomplete
						v-model="server.timeZone"
						:items="params.timeZones"
						item-value="id"
						item-text="description"
						label="Time Zone"
						name="timeZone"
						:error-messages="errors"
					>
					</v-autocomplete>
				</validation-provider>
				<validation-provider
					v-slot="{ errors }"
					slim
					rules="required"
					name="ueVersion"
				>
					<v-autocomplete
						v-model="server.ueVersion"
						:items="params.ueVersions"
						item-value="id"
						item-text="description"
						label="Unreal Engine Version"
						name="ueVersion"
						:error-messages="errors"
					>
					</v-autocomplete>
				</validation-provider>
				<validation-provider
					v-slot="{ errors }"
					slim
					rules="required"
					name="pageStyle"
				>
					<v-autocomplete
						v-model="server.pageStyle"
						:items="params.pageStyles"
						item-value="id"
						item-text="description"
						label="Page Style"
						name="pageStyle"
						:error-messages="errors"
					>
					</v-autocomplete>
				</validation-provider>
				<validation-provider
					v-slot="{ errors }"
					slim
					rules="required"
					name="simulationRunMode"
				>
					<v-autocomplete
						v-model="server.simulationRunMode"
						:items="params.simulationRunModes"
						item-value="id"
						item-text="description"
						label="Simulation run mode"
						name="simulationRunMode"
						:error-messages="errors"
					>
					</v-autocomplete>
				</validation-provider>
				<v-checkbox
					v-model="server.automaticResults"
					label="Automatic results"
					name="automaticResults"
				>
				</v-checkbox>
				<v-checkbox
					v-if="server.automaticResults"
					v-model="server.publishBolita"
					label="Publish Bolita"
					name="publishBolita"
				>
				</v-checkbox>
				<v-checkbox
					v-if="server.automaticResults"
					v-model="server.publishSingulaccion"
					label="Publish Singulaccion"
					name="publishSingulaccion"
				>
				</v-checkbox>
				<v-checkbox
					v-model="server.displayResults"
					label="Lottery results"
					name="lotteryResults"
				>
				</v-checkbox>
				<v-checkbox
					v-model="server.streamEnabled"
					label="Stream enabled"
					name="streamEnabled"
				>
				</v-checkbox>
			</v-col>
			<v-col>
				<div>
					<validation-provider
						v-slot="{ errors }"
						rules="required"
						slim
						name="twitchChannelName"
					>
						<v-text-field
							v-model.trim="server.twitchChannelName"
							label="Twitch channel name"
							name="twitchChannelName"
							:error-messages="errors"
							type="text"
						>
						</v-text-field>
					</validation-provider>
					<validation-provider
						v-if="server.streamEnabled"
						v-slot="{ errors }"
						rules="required|minValue:1|integer"
						slim
						name="hoursBeforeFirstSortitionToRurnOnStream"
					>
						<v-text-field
							v-model.trim="server.hoursBeforeFirstSortitionToTurnOnStream"
							label="Hours before first sortition to turn on stream"
							name="hoursBeforeFirstSortitionToRurnOnStream"
							:error-messages="errors"
							type="number"
						>
						</v-text-field>
					</validation-provider>
					<validation-provider
						v-if="server.streamEnabled"
						v-slot="{ errors }"
						rules="required|minValue:1|integer"
						slim
						name="hoursAfterLastSortitionToTurnOffStream"
					>
						<v-text-field
							v-model.trim="server.hoursAfterLastSortitionToTurnOffStream"
							label="Hours after last sortition to turn off stream"
							name="hoursAfterLastSortitionToTurnOffStream"
							:error-messages="errors"
							type="number"
						>
						</v-text-field>
					</validation-provider>
					<validation-provider
						v-if="server.streamEnabled"
						v-slot="{ errors }"
						slim
						name="instanceId"
					>
						<v-text-field
							v-model.trim="server.instanceId"
							label="Instance ID"
							name="instanceId"
							:error-messages="errors"
							type="text"
						>
						</v-text-field>
					</validation-provider>
				</div>
			</v-col>
		</v-row>
		<input type="submit" hidden />
	</v-form>
</template>

<script>
import { ValidationProvider, extend } from 'vee-validate';
import {
	required,
	oneOf,
	min_value as minValue,
	integer
} from 'vee-validate/dist/rules.js';

extend('required', {
	...required,
	message: 'This field is required'
});

extend('oneOf', oneOf);
extend('integer', {
	...integer,
	message: 'Must be an integer number'
});
extend('minValue', {
	...minValue,
	message: 'Must be greater than {min}.'
});

export default {
	name: 'ServerForm',
	components: {
		ValidationProvider
	},
	model: {
		prop: 'server'
	},
	props: {
		server: {
			type: Object,
			required: false,
			default: () => ({})
		},
		params: {
			type: Object,
			required: true
		}
	}
};
</script>
